export default "/images/vendor/flag-icons/flags/4x3/ad.svg?ae04a3ead396d8b17262512a17dcfbfe";